// Definicoes.js - VERSÃO CORRIGIDA COM CARDS E CONFIGURAÇÃO DE NOTÍCIAS
// 🔥 PERSONALIZAÇÃO REORGANIZADA - COR SECUNDÁRIA REMOVIDA
// 🔥 CORES PRÉ-DEFINIDAS INCLUINDO BRANCO - COLOR PICKER REMOVIDO
// 🔥 A PERSONALIZAÇÃO AGORA GUARDA NA EMPRESA (API) E SINCRONIZA COM O MODAL
// 🔥 CORRIGIDO: MENU TRANSFORMADO EM CARDS PARA CABEREM EM QUALQUER TAMANHO
// 🔥 REMOVIDO: TAB PREFERÊNCIAS (definidas apenas na criação da empresa)
// 🔥 ADICIONADO: CONFIGURAÇÃO DE NOTÍCIAS (fontes + ativação)
// 🔥 CORRIGIDO: NOTIFICA O DASHBOARD SOBRE MUDANÇAS NA CONFIGURAÇÃO DE NOTÍCIAS
// 🔥 ADICIONADO: IDIOMA NA PERSONALIZAÇÃO (movido da tab Sistema)
// 🔥 IDIOMAS DISPONÍVEIS: PORTUGUÊS E INGLÊS
// 🔥 SETA DO SELECT VISÍVEL NO DARK MODE
// 🔥 CORRIGIDO: COR DAS BOLINHAS APLICADA VIA JS COM !IMPORTANT (GARANTE 100% QUE APARECE)
// 🔥 ADICIONADO: RESTAURO DE BACKUP VIA UPLOAD JSON (apenas Superadmin)
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Definicoes.css';
import { Icon, Avatar } from './SharedComponents';

const API_BASE_URL = '/api';

export default function Definicoes() {
    // ==============================================
    // ESTADOS
    // ==============================================
    const [activeSection, setActiveSection] = useState('perfil');
    const [loading, setLoading] = useState(false);
    const [loggedUser, setLoggedUser] = useState(null);
    const [isSuperadmin, setIsSuperadmin] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [tempToast, setTempToast] = useState(null);
    const [empresaInfo, setEmpresaInfo] = useState(null);

    // ==============================================
    // ESTADO PARA MODAL DE PREVIEW DO BACKUP
    // ==============================================
    const [showPreviewModal, setShowPreviewModal] = useState(false);
    const [previewData, setPreviewData] = useState(null);
    const [previewLoading, setPreviewLoading] = useState(false);

    // ==============================================
    // 🔥 ESTADO PARA RESTAURO DE BACKUP
    // ==============================================
    const [restauroFile, setRestauroFile] = useState(null);
    const [restauroLoading, setRestauroLoading] = useState(false);
    const [restauroProgresso, setRestauroProgresso] = useState(0);
    const [showRestauroModal, setShowRestauroModal] = useState(false);
    const [restauroResultado, setRestauroResultado] = useState(null);

    // ==============================================
    // ESTADO PARA SELEÇÃO DE EMPRESA NO BACKUP
    // ==============================================
    const [empresasBackup, setEmpresasBackup] = useState([]);
    const [empresaSelecionada, setEmpresaSelecionada] = useState('');
    const [carregandoEmpresas, setCarregandoEmpresas] = useState(false);

    // ==============================================
    // ESTADO DO FORMULÁRIO DE PERFIL
    // ==============================================
    const [perfilData, setPerfilData] = useState({
        nome: '',
        email: '',
        empresaId: '',
        empresaNome: '',
        perfil: '',
        imagemPerfil: null
    });

    // ==============================================
    // ESTADO DO FORMULÁRIO DE SEGURANÇA
    // ==============================================
    const [segurancaData, setSegurancaData] = useState({
        senhaAtual: '',
        novaSenha: '',
        confirmarSenha: ''
    });

    // ==============================================
    // 🔥 ESTADO PARA PERSONALIZAÇÃO - APENAS COR PRIMÁRIA
    // ==============================================
    const [coresData, setCoresData] = useState({
        corPrimaria: '#6C9BCF'
    });
    const [coresLoading, setCoresLoading] = useState(false);

    // ==============================================
    // 🔥 ESTADO PARA IDIOMA (movido da tab Sistema)
    // ==============================================
    const [idiomaData, setIdiomaData] = useState({
        idioma: 'pt-PT'
    });
    const [idiomaLoading, setIdiomaLoading] = useState(false);

    // ==============================================
    // 🔥 ESTADO PARA CONFIGURAÇÃO DE NOTÍCIAS
    // ==============================================
    const [noticiasConfig, setNoticiasConfig] = useState({
        ativo: true,
        fontes: []
    });
    const [noticiasLoading, setNoticiasLoading] = useState(false);
    const [novaFonte, setNovaFonte] = useState({ nome: '', url: '' });
    const [editandoFonte, setEditandoFonte] = useState(null);

    // ==============================================
    // 🔥 CORES PRÉ-DEFINIDAS (INCLUINDO BRANCO)
    // ==============================================
    const coresPreDefinidas = [
        { nome: 'Azul RAF', cor: '#6C9BCF' },
        { nome: 'Branco', cor: '#FFFFFF' },
        { nome: 'Azul Escuro', cor: '#1a1a2e' },
        { nome: 'Azul Royal', cor: '#1a237e' },
        { nome: 'Azul Céu', cor: '#42a5f5' },
        { nome: 'Verde Esmeralda', cor: '#2e7d32' },
        { nome: 'Verde Menta', cor: '#26a69a' },
        { nome: 'Vermelho', cor: '#c62828' },
        { nome: 'Rosa', cor: '#ad1457' },
        { nome: 'Roxo', cor: '#6a1b9a' },
        { nome: 'Laranja', cor: '#e65100' },
        { nome: 'Amarelo', cor: '#f9a825' },
        { nome: 'Cinza', cor: '#37474f' },
        { nome: 'Cinza Claro', cor: '#78909c' },
        { nome: 'Preto', cor: '#000000' },
        { nome: 'Marrom', cor: '#4e342e' }
    ];

    // ==============================================
    // 🔥 IDIOMAS DISPONÍVEIS (APENAS PORTUGUÊS E INGLÊS)
    // ==============================================
    const idiomasDisponiveis = [
        { valor: 'pt-PT', label: 'Português' },
        { valor: 'en-US', label: 'English' }
    ];

    // ==============================================
    // ESTADO PARA BACKUP
    // ==============================================
    const [backupData, setBackupData] = useState({
        ultimoBackup: null,
        tamanhoBackup: '0 MB',
        backupsDisponiveis: [],
        backupEmAndamento: false
    });

    // ==============================================
    // 🔥 EFEITO CRÍTICO: APLICAR COR DAS BOLINHAS VIA JS COM !IMPORTANT
    // Isto garante que a cor aparece SEMPRE, mesmo que o CSS tenha
    // regras com `background` ou `!important` em dark mode.
    // ==============================================
    useEffect(() => {
        const aplicarCoresNasBolinhas = () => {
            const bolinhas = document.querySelectorAll('.cor-option[data-cor]');
            bolinhas.forEach((bolinha) => {
                const cor = bolinha.getAttribute('data-cor');
                if (cor) {
                    bolinha.style.setProperty('background-color', cor, 'important');
                }
            });
        };

        aplicarCoresNasBolinhas();

        const observer = new MutationObserver(() => {
            aplicarCoresNasBolinhas();
        });

        observer.observe(document.body, {
            attributes: true,
            attributeFilter: ['class']
        });

        return () => observer.disconnect();
    }, [coresData.corPrimaria, activeSection]);

    // ==============================================
    // FUNÇÕES AUXILIARES
    // ==============================================
    const showTempToast = (title, message, type = 'success') => {
        setTempToast({ title, message, type });
        setTimeout(() => setTempToast(null), 3000);
    };

    const getImagemUrl = (imagemPerfil) => {
        if (!imagemPerfil) return null;
        if (imagemPerfil.startsWith('http://') || imagemPerfil.startsWith('https://')) {
            return imagemPerfil;
        }
        let cleanPath = imagemPerfil.replace(/^\/+/, '');
        if (cleanPath.startsWith('uploads/')) {
            return `/${cleanPath}`;
        }
        if (!cleanPath.startsWith('uploads/')) {
            cleanPath = `uploads/${cleanPath}`;
        }
        return `/${cleanPath}`;
    };

    const extrairEmpresaId = (empresa) => {
        if (!empresa) return null;
        if (typeof empresa === 'string') return empresa;
        if (typeof empresa === 'object' && empresa._id) return empresa._id;
        if (typeof empresa === 'object' && empresa.id) return empresa.id;
        return null;
    };

    const obterEmpresaIdDoUtilizador = (user) => {
        if (!user) return null;
        let id = extrairEmpresaId(user.empresaId);
        if (id) return id;
        id = extrairEmpresaId(user.empresa);
        if (id) return id;
        if (user.empresa && typeof user.empresa === 'object' && user.empresa._id) {
            return user.empresa._id;
        }
        if (user.empresa && typeof user.empresa === 'object' && user.empresa.id) {
            return user.empresa.id;
        }
        return null;
    };

    // ==============================================
    // 🔥 FUNÇÃO PARA CALCULAR BRILHO DA COR
    // ==============================================
    const calcularBrilho = (cor) => {
        if (!cor) return 0;
        let hex = cor.replace('#', '');
        if (hex.length === 3) {
            hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        }
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);
        return (r * 299 + g * 587 + b * 114) / 1000;
    };

    // ==============================================
    // 🔥 FUNÇÃO PARA NOTIFICAR O DASHBOARD SOBRE MUDANÇAS
    // ==============================================
    const notificarDashboard = (userId, noticiasConfig) => {
        window.dispatchEvent(new CustomEvent('userUpdated', {
            detail: {
                userId: userId,
                data: { noticiasConfig: noticiasConfig }
            }
        }));

        window.dispatchEvent(new CustomEvent('noticiasConfigAtualizada', {
            detail: noticiasConfig
        }));

        console.log('📢 Eventos disparados para notificar o Dashboard:', {
            userId,
            noticiasConfig
        });
    };

    // ==============================================
    // 🔥 FUNÇÃO PARA CARREGAR CORES E IDIOMA DA EMPRESA VIA API
    // ==============================================
    const carregarCoresDaEmpresa = async (empresaId) => {
        if (!empresaId) {
            console.warn('⚠️ Sem empresa ID para carregar cores');
            return;
        }

        try {
            setCoresLoading(true);
            const token = localStorage.getItem('token');
            if (!token) return;

            const response = await axios.get(`${API_BASE_URL}/empresas/${empresaId}`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            if (response.data && response.data.success) {
                const empresa = response.data.data;
                const corPrimaria = empresa.configuracoes?.tema?.corPrimaria || '#6C9BCF';
                const idioma = empresa.configuracoes?.idioma || 'pt-PT';

                console.log('🎨 Cor primária carregada da empresa:', corPrimaria);
                console.log('🌐 Idioma carregado da empresa:', idioma);

                setCoresData({ corPrimaria });
                setIdiomaData({ idioma });

                document.documentElement.style.setProperty('--header-color', corPrimaria);
            }
        } catch (err) {
            console.error('❌ Erro ao carregar cores da empresa:', err);
        } finally {
            setCoresLoading(false);
        }
    };

    // ==============================================
    // 🔥 FUNÇÃO PARA SALVAR IDIOMA NA EMPRESA VIA API
    // ==============================================
    const salvarIdiomaNaEmpresa = async () => {
        const empresaId = perfilData.empresaId;
        if (!empresaId) {
            showTempToast('Erro', 'Nenhuma empresa associada à sua conta', 'danger');
            return;
        }

        if (!idiomaData.idioma) {
            showTempToast('Erro', 'Selecione um idioma', 'danger');
            return;
        }

        try {
            setIdiomaLoading(true);
            const token = localStorage.getItem('token');
            if (!token) {
                showTempToast('Erro', 'Sessão expirada', 'danger');
                return;
            }

            const responseGet = await axios.get(`${API_BASE_URL}/empresas/${empresaId}`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            if (!responseGet.data || !responseGet.data.success) {
                showTempToast('Erro', 'Erro ao carregar dados da empresa', 'danger');
                return;
            }

            const empresaAtual = responseGet.data.data;

            const payload = {
                configuracoes: {
                    ...empresaAtual.configuracoes,
                    idioma: idiomaData.idioma
                }
            };

            console.log('📤 A salvar idioma na empresa:', payload);

            const response = await axios.put(`${API_BASE_URL}/empresas/${empresaId}`, payload, {
                headers: { Authorization: `Bearer ${token}` }
            });

            if (response.data && response.data.success) {
                showTempToast('Sucesso', 'Idioma salvo com sucesso!', 'success');

                setEmpresaInfo(prev => ({
                    ...prev,
                    configuracoes: {
                        ...prev?.configuracoes,
                        idioma: idiomaData.idioma
                    }
                }));

            } else {
                showTempToast('Erro', 'Erro ao salvar idioma', 'danger');
            }
        } catch (err) {
            console.error('❌ Erro ao salvar idioma:', err);
            showTempToast('Erro', err.response?.data?.erro || 'Erro ao salvar idioma', 'danger');
        } finally {
            setIdiomaLoading(false);
        }
    };

    // ==============================================
    // 🔥 FUNÇÃO PARA SALVAR COR NA EMPRESA VIA API
    // ==============================================
    const salvarCorNaEmpresa = async () => {
        const empresaId = perfilData.empresaId;
        if (!empresaId) {
            showTempToast('Erro', 'Nenhuma empresa associada à sua conta', 'danger');
            return;
        }

        if (!coresData.corPrimaria) {
            showTempToast('Erro', 'Selecione uma cor', 'danger');
            return;
        }

        try {
            setCoresLoading(true);
            const token = localStorage.getItem('token');
            if (!token) {
                showTempToast('Erro', 'Sessão expirada', 'danger');
                return;
            }

            const responseGet = await axios.get(`${API_BASE_URL}/empresas/${empresaId}`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            if (!responseGet.data || !responseGet.data.success) {
                showTempToast('Erro', 'Erro ao carregar dados da empresa', 'danger');
                return;
            }

            const empresaAtual = responseGet.data.data;

            const payload = {
                configuracoes: {
                    ...empresaAtual.configuracoes,
                    tema: {
                        ...empresaAtual.configuracoes?.tema,
                        corPrimaria: coresData.corPrimaria
                    }
                }
            };

            console.log('📤 A salvar cor na empresa:', payload);

            const response = await axios.put(`${API_BASE_URL}/empresas/${empresaId}`, payload, {
                headers: { Authorization: `Bearer ${token}` }
            });

            if (response.data && response.data.success) {
                document.documentElement.style.setProperty('--header-color', coresData.corPrimaria);

                showTempToast('Sucesso', 'Cor personalizada salva com sucesso!', 'success');

                window.dispatchEvent(new CustomEvent('coresAtualizadas', {
                    detail: {
                        empresaId: empresaId,
                        corPrimaria: coresData.corPrimaria,
                        source: 'Definicoes.js'
                    }
                }));

                setEmpresaInfo(prev => ({
                    ...prev,
                    configuracoes: {
                        ...prev?.configuracoes,
                        tema: {
                            ...prev?.configuracoes?.tema,
                            corPrimaria: coresData.corPrimaria
                        }
                    }
                }));

            } else {
                showTempToast('Erro', 'Erro ao salvar cor', 'danger');
            }
        } catch (err) {
            console.error('❌ Erro ao salvar cor:', err);
            showTempToast('Erro', err.response?.data?.erro || 'Erro ao salvar cor', 'danger');
        } finally {
            setCoresLoading(false);
        }
    };

    // ==============================================
    // 🔥 FUNÇÃO PARA RESETAR COR
    // ==============================================
    const resetarCor = () => {
        setCoresData({
            corPrimaria: '#6C9BCF'
        });
        showTempToast('Info', 'Cor restaurada para o padrão. Clique em Salvar para aplicar.', 'info');
    };

    // ==============================================
    // 🔥 FUNÇÕES PARA CONFIGURAÇÃO DE NOTÍCIAS
    // ==============================================

    const carregarConfigNoticias = async () => {
        try {
            const token = localStorage.getItem('token');
            if (!token) return;

            const configLocal = JSON.parse(localStorage.getItem('noticias_config') || 'null');

            const response = await axios.get(`${API_BASE_URL}/users/me`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            if (response.data && response.data.success) {
                const userData = response.data.data;

                if (userData.noticiasConfig) {
                    setNoticiasConfig({
                        ativo: userData.noticiasConfig.ativo !== undefined ? userData.noticiasConfig.ativo : true,
                        fontes: userData.noticiasConfig.fontes || []
                    });

                    localStorage.setItem('noticias_config', JSON.stringify({
                        ativo: userData.noticiasConfig.ativo !== undefined ? userData.noticiasConfig.ativo : true,
                        fontes: userData.noticiasConfig.fontes || []
                    }));
                } else if (configLocal) {
                    setNoticiasConfig(configLocal);
                } else {
                    const fontesPadrao = [
                        { id: 1, nome: 'VOA Português - Moçambique', url: 'https://www.voaportugues.com/z/2632', ativo: true },
                        { id: 2, nome: 'DW - Moçambique', url: 'https://www.dw.com/pt-002/mo%C3%A7ambique/s-30380', ativo: true },
                        { id: 3, nome: 'O País', url: 'https://opais.co.mz/feed', ativo: true },
                        { id: 4, nome: 'Canal de Moçambique', url: 'https://canaldemozambique.com/feed', ativo: true },
                        { id: 5, nome: 'Google News - Moçambique', url: 'https://news.google.com/rss/search?q=Mo%C3%A7ambique+economia&hl=pt&gl=MZ&ceid=MZ:pt', ativo: true }
                    ];
                    setNoticiasConfig({
                        ativo: true,
                        fontes: fontesPadrao
                    });
                    localStorage.setItem('noticias_config', JSON.stringify({ ativo: true, fontes: fontesPadrao }));
                }
            }
        } catch (err) {
            console.error('❌ Erro ao carregar configuração de notícias:', err);
            const configLocal = JSON.parse(localStorage.getItem('noticias_config') || 'null');
            if (configLocal) {
                setNoticiasConfig(configLocal);
            }
        }
    };

    const salvarConfigNoticias = async () => {
        try {
            setNoticiasLoading(true);
            const token = localStorage.getItem('token');
            if (!token) {
                showTempToast('Erro', 'Sessão expirada', 'danger');
                return;
            }

            const userId = loggedUser?._id;
            if (!userId) {
                showTempToast('Erro', 'Utilizador não identificado', 'danger');
                return;
            }

            console.log('📤 Salvando configuração de notícias:', {
                userId,
                noticiasConfig: {
                    ativo: noticiasConfig.ativo,
                    fontes: noticiasConfig.fontes
                }
            });

            localStorage.setItem('noticias_config', JSON.stringify({
                ativo: noticiasConfig.ativo,
                fontes: noticiasConfig.fontes
            }));

            const usuarioSalvo = JSON.parse(localStorage.getItem('usuario') || '{}');
            if (usuarioSalvo._id === userId || usuarioSalvo.id === userId) {
                usuarioSalvo.noticiasConfig = {
                    ativo: noticiasConfig.ativo,
                    fontes: noticiasConfig.fontes
                };
                localStorage.setItem('usuario', JSON.stringify(usuarioSalvo));
            }

            const response = await axios.put(
                `${API_BASE_URL}/users/${userId}`,
                {
                    noticiasConfig: {
                        ativo: noticiasConfig.ativo,
                        fontes: noticiasConfig.fontes
                    }
                },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (response.data && response.data.success) {
                showTempToast('Sucesso', 'Configuração de notícias salva!', 'success');

                notificarDashboard(userId, {
                    ativo: noticiasConfig.ativo,
                    fontes: noticiasConfig.fontes
                });

                setLoggedUser(prev => ({
                    ...prev,
                    noticiasConfig: {
                        ativo: noticiasConfig.ativo,
                        fontes: noticiasConfig.fontes
                    }
                }));

            } else {
                showTempToast('Erro', 'Erro ao salvar configuração de notícias', 'danger');
            }
        } catch (err) {
            console.error('❌ Erro ao salvar configuração de notícias:', err);
            showTempToast('Erro', err.response?.data?.erro || 'Erro ao salvar configuração', 'danger');
        } finally {
            setNoticiasLoading(false);
        }
    };

    const adicionarFonte = () => {
        if (!novaFonte.nome.trim()) {
            showTempToast('Erro', 'Digite um nome para a fonte', 'danger');
            return;
        }
        if (!novaFonte.url.trim()) {
            showTempToast('Erro', 'Digite a URL da fonte', 'danger');
            return;
        }
        if (noticiasConfig.fontes.length >= 5) {
            showTempToast('Limite atingido', 'Máximo de 5 fontes permitidas', 'warning');
            return;
        }

        const novaFonteObj = {
            id: Date.now(),
            nome: novaFonte.nome.trim(),
            url: novaFonte.url.trim(),
            ativo: true
        };

        setNoticiasConfig(prev => ({
            ...prev,
            fontes: [...prev.fontes, novaFonteObj]
        }));

        setNovaFonte({ nome: '', url: '' });
        showTempToast('Sucesso', 'Fonte adicionada!', 'success');
    };

    const removerFonte = (fonteId) => {
        setNoticiasConfig(prev => ({
            ...prev,
            fontes: prev.fontes.filter(f => f.id !== fonteId)
        }));
        showTempToast('Sucesso', 'Fonte removida', 'success');
    };

    const toggleFonteAtiva = (fonteId) => {
        setNoticiasConfig(prev => ({
            ...prev,
            fontes: prev.fontes.map(f =>
                f.id === fonteId ? { ...f, ativo: !f.ativo } : f
            )
        }));
    };

    const toggleModuloNoticias = () => {
        setNoticiasConfig(prev => ({
            ...prev,
            ativo: !prev.ativo
        }));
    };

    // ==============================================
    // FUNÇÃO PARA GERAR NOME DO FICHEIRO CONSISTENTE
    // ==============================================
    const gerarNomeFicheiro = (empresaId = null) => {
        const dataStr = new Date().toISOString().split('T')[0];
        let nome = '';

        if (isSuperadmin) {
            if (empresaId) {
                const empresaEncontrada = empresasBackup.find(emp => emp._id === empresaId);
                if (empresaEncontrada) {
                    const nomeLimpo = empresaEncontrada.nome
                        .normalize('NFD')
                        .replace(/[\u0300-\u036f]/g, '')
                        .toLowerCase()
                        .replace(/[^a-z0-9]/g, '_')
                        .replace(/_+/g, '_')
                        .replace(/^_|_$/g, '');
                    nome = `backup_${nomeLimpo}_${dataStr}`;
                } else {
                    nome = `backup_empresa_${empresaId.slice(-6)}_${dataStr}`;
                }
            } else {
                nome = `backup_completo_${dataStr}`;
            }
        } else if (isAdmin && perfilData.empresaNome && perfilData.empresaNome !== 'Sem empresa') {
            const nomeLimpo = perfilData.empresaNome
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toLowerCase()
                .replace(/[^a-z0-9]/g, '_')
                .replace(/_+/g, '_')
                .replace(/^_|_$/g, '');
            nome = `backup_${nomeLimpo}_${dataStr}`;
        } else {
            nome = `backup_completo_${dataStr}`;
        }

        return nome;
    };

    const getNomeEmpresaParaPreview = (empresaId = null) => {
        if (isSuperadmin) {
            if (empresaId) {
                const empresaEncontrada = empresasBackup.find(emp => emp._id === empresaId);
                if (empresaEncontrada) return empresaEncontrada.nome;
                return 'Empresa Específica';
            }
            return 'Completo';
        } else if (isAdmin && perfilData.empresaNome && perfilData.empresaNome !== 'Sem empresa') {
            return perfilData.empresaNome;
        }
        return 'Completo';
    };

    // ==============================================
    // CARREGAR EMPRESAS PARA BACKUP
    // ==============================================
    const carregarEmpresasBackup = async () => {
        if (!isSuperadmin) return;
        try {
            setCarregandoEmpresas(true);
            const token = localStorage.getItem('token');
            if (!token) return;
            const response = await axios.get(
                `${API_BASE_URL}/backup/empresas`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            if (response.data && response.data.success) {
                setEmpresasBackup(response.data.data);
            }
        } catch (err) {
            console.error('❌ Erro ao carregar empresas:', err);
        } finally {
            setCarregandoEmpresas(false);
        }
    };

    useEffect(() => {
        if (activeSection === 'backup' && isSuperadmin) {
            carregarEmpresasBackup();
        }
    }, [activeSection, isSuperadmin]);

    // ==============================================
    // BUSCAR DADOS DO UTILIZADOR E EMPRESA
    // ==============================================
    const fetchLoggedUser = async () => {
        try {
            const token = localStorage.getItem('token');
            if (!token) return null;

            const response = await axios.get(`${API_BASE_URL}/users/me`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            if (response.data && response.data.success) {
                const userData = response.data.data;
                setLoggedUser(userData);
                setIsSuperadmin(userData.perfil === 'Superadmin');
                setIsAdmin(userData.perfil === 'Admin' || userData.perfil === 'Superadmin');

                const empresaId = obterEmpresaIdDoUtilizador(userData);
                let empresaNome = userData.empresaNome || userData.empresa || 'Sem empresa';

                if (empresaId) {
                    try {
                        const empresaResponse = await axios.get(`${API_BASE_URL}/empresas/${empresaId}`, {
                            headers: { Authorization: `Bearer ${token}` }
                        });
                        if (empresaResponse.data && empresaResponse.data.success) {
                            const empresa = empresaResponse.data.data || empresaResponse.data.empresa;
                            if (empresa) {
                                empresaNome = empresa.nome || empresaNome;
                                setEmpresaInfo(empresa);

                                await carregarCoresDaEmpresa(empresaId);
                            }
                        }
                    } catch (err) {
                        console.warn('⚠️ Erro ao buscar empresa:', err.message);
                    }
                }

                setPerfilData({
                    nome: userData.nome || '',
                    email: userData.email || '',
                    empresaId: empresaId || '',
                    empresaNome: empresaNome,
                    perfil: userData.perfil || '',
                    imagemPerfil: userData.imagemPerfil || null
                });

                await carregarConfigNoticias();

                return userData;
            }
        } catch (err) {
            console.error('❌ Erro ao buscar utilizador:', err);
            const storedUser = JSON.parse(localStorage.getItem('usuario') || '{}');
            if (storedUser && storedUser._id) {
                setLoggedUser(storedUser);
                setIsSuperadmin(storedUser.perfil === 'Superadmin');
                setIsAdmin(storedUser.perfil === 'Admin' || storedUser.perfil === 'Superadmin');
                const empresaId = obterEmpresaIdDoUtilizador(storedUser) || '';
                setPerfilData({
                    nome: storedUser.nome || '',
                    email: storedUser.email || '',
                    empresaId: empresaId,
                    empresaNome: storedUser.empresaNome || storedUser.empresa || 'Sem empresa',
                    perfil: storedUser.perfil || '',
                    imagemPerfil: storedUser.imagemPerfil || null
                });
                if (empresaId) {
                    await carregarCoresDaEmpresa(empresaId);
                }
                await carregarConfigNoticias();
                return storedUser;
            }
        }
        return null;
    };

    // ==============================================
    // CARREGAR DADOS INICIAIS
    // ==============================================
    useEffect(() => {
        const carregarDados = async () => {
            await fetchLoggedUser();
        };
        carregarDados();
    }, []);

    // ==============================================
    // 🔥 ESCUTAR EVENTO DE CORES ATUALIZADAS
    // ==============================================
    useEffect(() => {
        const handleCoresAtualizadas = (event) => {
            const { empresaId, corPrimaria } = event.detail || {};
            if (empresaId === perfilData.empresaId) {
                console.log('🔄 Cor atualizada por outro componente:', corPrimaria);
                setCoresData({ corPrimaria });
                document.documentElement.style.setProperty('--header-color', corPrimaria);
            }
        };

        window.addEventListener('coresAtualizadas', handleCoresAtualizadas);
        return () => window.removeEventListener('coresAtualizadas', handleCoresAtualizadas);
    }, [perfilData.empresaId]);

    // ==============================================
    // ATUALIZAR PERFIL
    // ==============================================
    const atualizarPerfil = async () => {
        if (!perfilData.nome.trim()) {
            showTempToast('Erro', 'O nome é obrigatório', 'danger');
            return;
        }

        try {
            setLoading(true);
            const token = localStorage.getItem('token');
            if (!token) {
                showTempToast('Erro', 'Sessão expirada', 'danger');
                return;
            }

            const updateData = { nome: perfilData.nome };

            await axios.put(
                `${API_BASE_URL}/users/${loggedUser._id}`,
                updateData,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            showTempToast('Sucesso', 'Perfil atualizado com sucesso!', 'success');
            await fetchLoggedUser();

        } catch (err) {
            console.error('❌ Erro ao atualizar perfil:', err);
            showTempToast('Erro', 'Erro ao atualizar perfil', 'danger');
        } finally {
            setLoading(false);
        }
    };

    // ==============================================
    // ALTERAR SENHA
    // ==============================================
    const alterarSenha = async () => {
        if (!segurancaData.senhaAtual) {
            showTempToast('Erro', 'Digite a senha atual', 'danger');
            return;
        }
        if (!segurancaData.novaSenha || segurancaData.novaSenha.length < 6) {
            showTempToast('Erro', 'A nova senha deve ter no mínimo 6 caracteres', 'danger');
            return;
        }
        if (segurancaData.novaSenha !== segurancaData.confirmarSenha) {
            showTempToast('Erro', 'As senhas não coincidem', 'danger');
            return;
        }

        try {
            setLoading(true);
            const token = localStorage.getItem('token');
            if (!token) {
                showTempToast('Erro', 'Sessão expirada', 'danger');
                return;
            }

            await axios.put(
                `${API_BASE_URL}/users/${loggedUser._id}/senha`,
                {
                    senhaAtual: segurancaData.senhaAtual,
                    novaSenha: segurancaData.novaSenha
                },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            showTempToast('Sucesso', 'Senha alterada com sucesso!', 'success');
            setSegurancaData({ senhaAtual: '', novaSenha: '', confirmarSenha: '' });

        } catch (err) {
            console.error('❌ Erro ao alterar senha:', err);
            const msg = err.response?.data?.erro || 'Erro ao alterar senha';
            showTempToast('Erro', msg, 'danger');
        } finally {
            setLoading(false);
        }
    };

    // ==============================================
    // FUNÇÕES DE BACKUP
    // ==============================================
    const baixarBackup = async () => {
        try {
            setBackupData(prev => ({ ...prev, backupEmAndamento: true }));
            const token = localStorage.getItem('token');
            if (!token) {
                showTempToast('Erro', 'Sessão expirada', 'danger');
                setBackupData(prev => ({ ...prev, backupEmAndamento: false }));
                return;
            }

            let url = `${API_BASE_URL}/backup/download`;
            const empresaIdParaBackup = (isSuperadmin && empresaSelecionada) ? empresaSelecionada : null;
            if (empresaIdParaBackup) {
                url += `?empresaId=${empresaIdParaBackup}`;
            }

            showTempToast('⏳ A gerar backup...', 'A preparar o ficheiro de backup...', 'info');

            const response = await axios.get(
                url,
                {
                    headers: { Authorization: `Bearer ${token}` },
                    responseType: 'blob'
                }
            );

            const filename = gerarNomeFicheiro(empresaIdParaBackup) + '.json';
            console.log(`📁 Nome do ficheiro gerado: ${filename}`);

            const urlBlob = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = urlBlob;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(urlBlob);

            const now = new Date();
            const tamanhoMB = (response.data.size / (1024 * 1024)).toFixed(2);

            let tipoBackup = 'Completo';
            if (isSuperadmin && empresaSelecionada) {
                tipoBackup = 'Empresa Específica';
            } else if (isAdmin) {
                tipoBackup = 'Empresa Específica';
            } else if (filename.includes('completo')) {
                tipoBackup = 'Completo';
            }

            const novoBackup = {
                id: Date.now(),
                nome: filename,
                data: now.toISOString(),
                tamanho: `${tamanhoMB} MB`,
                tipo: tipoBackup
            };

            setBackupData(prev => ({
                ...prev,
                ultimoBackup: now.toISOString(),
                tamanhoBackup: `${tamanhoMB} MB`,
                backupsDisponiveis: [novoBackup, ...prev.backupsDisponiveis],
                backupEmAndamento: false
            }));

            showTempToast('✅ Backup Baixado', `Backup "${filename}" baixado com sucesso!`, 'success');

        } catch (err) {
            console.error('❌ Erro ao baixar backup:', err);
            setBackupData(prev => ({ ...prev, backupEmAndamento: false }));
            showTempToast('Erro', err.response?.data?.erro || 'Falha ao baixar o backup', 'danger');
        }
    };

    const previewBackup = async () => {
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                showTempToast('Erro', 'Sessão expirada', 'danger');
                return;
            }

            setPreviewLoading(true);
            setShowPreviewModal(true);

            let url = `${API_BASE_URL}/backup/preview`;
            const empresaIdParaBackup = (isSuperadmin && empresaSelecionada) ? empresaSelecionada : null;
            if (empresaIdParaBackup) {
                url += `?empresaId=${empresaIdParaBackup}`;
            }

            const response = await axios.get(
                url,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (response.data && response.data.success) {
                const dados = response.data.data;

                // 🔥 Fallback se o backend não enviar estes campos
                if (!dados.nome) {
                    dados.nome = gerarNomeFicheiro(empresaIdParaBackup) + '.json';
                }
                if (!dados.nomeEmpresa) {
                    dados.nomeEmpresa = getNomeEmpresaParaPreview(empresaIdParaBackup);
                }
                if (!dados.tipoBackup) {
                    dados.tipoBackup = empresaIdParaBackup ? 'Empresa Específica' : 'Completo';
                }

                console.log('📊 Preview do backup:', dados);
                setPreviewData(dados);
            } else {
                showTempToast('Erro', 'Falha ao obter informações do backup', 'danger');
                setShowPreviewModal(false);
            }
        } catch (err) {
            console.error('❌ Erro ao gerar preview:', err);
            showTempToast('Erro', err.response?.data?.erro || 'Falha ao gerar preview', 'danger');
            setShowPreviewModal(false);
        } finally {
            setPreviewLoading(false);
        }
    };

    const closePreviewModal = () => {
        setShowPreviewModal(false);
        setPreviewData(null);
        setPreviewLoading(false);
    };

    const eliminarBackup = (backupId) => {
        setBackupData(prev => ({
            ...prev,
            backupsDisponiveis: prev.backupsDisponiveis.filter(b => b.id !== backupId)
        }));
        showTempToast('Backup Eliminado', 'O registo do backup foi removido!', 'success');
    };

    // ==============================================
    // 🔥 FUNÇÕES DE RESTAURO DE BACKUP
    // ==============================================
    const abrirModalRestauro = () => {
        setRestauroFile(null);
        setRestauroResultado(null);
        setRestauroProgresso(0);
        setShowRestauroModal(true);
    };

    const fecharModalRestauro = () => {
        if (restauroLoading) return;
        setShowRestauroModal(false);
        setRestauroFile(null);
        setRestauroResultado(null);
        setRestauroProgresso(0);
    };

    const handleFileChangeRestauro = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        if (!file.name.toLowerCase().endsWith('.json')) {
            showTempToast('Erro', 'Apenas ficheiros .json são permitidos', 'danger');
            return;
        }

        const MAX_SIZE = 500 * 1024 * 1024;
        if (file.size > MAX_SIZE) {
            showTempToast('Erro', 'Ficheiro demasiado grande (máx. 500 MB)', 'danger');
            return;
        }

        setRestauroFile(file);
        setRestauroResultado(null);
    };

    const executarRestauro = async () => {
        if (!restauroFile) {
            showTempToast('Erro', 'Selecione um ficheiro de backup', 'danger');
            return;
        }

        const confirmado = window.confirm(
            `⚠️ ATENÇÃO!\n\n` +
            `Vai restaurar o backup "${restauroFile.name}".\n\n` +
            `Esta ação vai:\n` +
            `• Inserir documentos novos\n` +
            `• Atualizar documentos existentes (com o mesmo _id)\n\n` +
            `Tem a certeza que quer continuar?`
        );

        if (!confirmado) return;

        try {
            setRestauroLoading(true);
            setRestauroProgresso(0);
            setRestauroResultado(null);

            const token = localStorage.getItem('token');
            if (!token) {
                showTempToast('Erro', 'Sessão expirada', 'danger');
                return;
            }

            const formData = new FormData();
            formData.append('backup', restauroFile);

            const response = await axios.post(
                `${API_BASE_URL}/backup/restore`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data'
                    },
                    onUploadProgress: (progressEvent) => {
                        const percent = Math.round(
                            (progressEvent.loaded * 100) / progressEvent.total
                        );
                        setRestauroProgresso(percent);
                    }
                }
            );

            if (response.data && response.data.success) {
                setRestauroResultado({
                    success: true,
                    mensagem: response.data.mensagem,
                    ...response.data.data
                });
                showTempToast('✅ Restauro Concluído', response.data.mensagem, 'success');

                setTimeout(() => {
                    window.location.reload();
                }, 2500);

            } else {
                setRestauroResultado({
                    success: false,
                    mensagem: response.data?.erro || 'Erro desconhecido',
                    ...response.data?.data
                });
                showTempToast('Erro', response.data?.erro || 'Erro ao restaurar', 'danger');
            }
        } catch (err) {
            console.error('❌ Erro ao restaurar backup:', err);

            const msg = err.response?.data?.erro || 'Erro ao restaurar backup';
            setRestauroResultado({
                success: false,
                mensagem: msg,
                erros: err.response?.data?.data?.erros || []
            });

            showTempToast('Erro', msg, 'danger');
        } finally {
            setRestauroLoading(false);
        }
    };

    // ==============================================
    // RENDER TOAST
    // ==============================================
    const renderToast = () => {
        if (!tempToast) return null;
        return (
            <div className={`definicoes-toast ${tempToast.type}`}>
                <div className="toast-icon">
                    <Icon name={tempToast.type === 'success' ? 'check_circle' : tempToast.type === 'info' ? 'info' : 'error'} size={20} />
                </div>
                <div className="toast-content">
                    <div className="toast-title">{tempToast.title}</div>
                    <div className="toast-message">{tempToast.message}</div>
                </div>
                <button className="toast-close" onClick={() => setTempToast(null)}>×</button>
            </div>
        );
    };

    // ==============================================
    // RENDER MODAL DE PREVIEW DO BACKUP
    // ==============================================
    const renderPreviewModal = () => {
        if (!showPreviewModal) return null;

        return (
            <div className="preview-modal-overlay" onClick={closePreviewModal}>
                <div className="preview-modal" onClick={(e) => e.stopPropagation()}>
                    <div className="preview-modal-header">
                        <h2>
                            <Icon name="visibility" size={24} color="var(--apple-blue)" />
                            Informações do Backup
                        </h2>
                        <button className="preview-modal-close" onClick={closePreviewModal}>×</button>
                    </div>

                    <div className="preview-modal-body">
                        {previewLoading ? (
                            <div className="preview-loading">
                                <div className="spinner"></div>
                                <p>A carregar informações...</p>
                            </div>
                        ) : previewData ? (
                            <>
                                <div className="preview-metadata">
                                    <div className="preview-metadata-item">
                                        <span className="preview-label">📅 Data</span>
                                        <span className="preview-value">
                                            {new Date(previewData.metadata.data).toLocaleString('pt-PT')}
                                        </span>
                                    </div>
                                    <div className="preview-metadata-item">
                                        <span className="preview-label">📁 Total de Coleções</span>
                                        <span className="preview-value">{previewData.metadata.totalColecoes}</span>
                                    </div>
                                    <div className="preview-metadata-item">
                                        <span className="preview-label">📄 Total de Documentos</span>
                                        <span className="preview-value">{previewData.metadata.totalDocumentos}</span>
                                    </div>

                                    {/* 🔥 NOVO: Valores Decimal128 */}
                                    {previewData.metadata.totalDecimais !== undefined && (
                                        <div className="preview-metadata-item">
                                            <span className="preview-label">💰 Valores Decimal128</span>
                                            <span className="preview-value">{previewData.metadata.totalDecimais}</span>
                                        </div>
                                    )}

                                    {/* 🔥 NOVO: Versão do MongoDB */}
                                    {previewData.metadata.mongoVersao && (
                                        <div className="preview-metadata-item">
                                            <span className="preview-label">🍃 MongoDB</span>
                                            <span className="preview-value">{previewData.metadata.mongoVersao}</span>
                                        </div>
                                    )}

                                    <div className="preview-metadata-item">
                                        <span className="preview-label">📦 Tamanho</span>
                                        <span className="preview-value">{previewData.tamanho}</span>
                                    </div>
                                    <div className="preview-metadata-item">
                                        <span className="preview-label">📋 Nome do Ficheiro</span>
                                        <span className="preview-value" style={{ wordBreak: 'break-all', fontSize: '0.8rem' }}>
                                            {previewData.nome}
                                        </span>
                                    </div>
                                    <div className="preview-metadata-item">
                                        <span className="preview-label">🏷️ Tipo</span>
                                        <span className="preview-value">
                                            {previewData.nomeEmpresa && previewData.nomeEmpresa !== 'Completo' && previewData.nomeEmpresa !== 'TODAS' ? (
                                                <span className="tipo-empresa">🏢 {previewData.nomeEmpresa}</span>
                                            ) : previewData.tipoBackup === 'Empresa Específica' ? (
                                                <span className="tipo-empresa">🏢 Empresa Específica</span>
                                            ) : (
                                                <span className="tipo-completo">🌐 Backup Completo</span>
                                            )}
                                        </span>
                                    </div>
                                </div>

                                <div className="preview-colecoes">
                                    <h4>📋 Coleções Exportadas</h4>
                                    <div className="preview-colecoes-list">
                                        {previewData.colecoes && previewData.colecoes.length > 0 ? (
                                            previewData.colecoes.map((colecao, index) => (
                                                <div key={index} className="preview-colecao-item">
                                                    <span className="colecao-nome">
                                                        {colecao.icone && `${colecao.icone} `}
                                                        {colecao.nome}
                                                    </span>
                                                    <span className="colecao-total">{colecao.total} documentos</span>
                                                </div>
                                            ))
                                        ) : (
                                            <div className="preview-colecao-item">
                                                <span className="colecao-nome">Nenhuma coleção exportada</span>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="preview-footer">
                                    <button className="btn-preview-close" onClick={closePreviewModal}>
                                        Fechar
                                    </button>
                                </div>
                            </>
                        ) : (
                            <div className="preview-empty">
                                <Icon name="info" size={48} color="var(--apple-gray)" />
                                <p>Não foi possível carregar as informações</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    };

    // ==============================================
    // 🔥 RENDER MODAL DE RESTAURO
    // ==============================================
    const renderRestauroModal = () => {
        if (!showRestauroModal) return null;

        return (
            <div className="preview-modal-overlay" onClick={fecharModalRestauro}>
                <div className="preview-modal" onClick={(e) => e.stopPropagation()}>
                    <div className="preview-modal-header">
                        <h2>
                            <Icon name="restore" size={24} color="var(--apple-red)" />
                            Restaurar Backup
                        </h2>
                        <button
                            className="preview-modal-close"
                            onClick={fecharModalRestauro}
                            disabled={restauroLoading}
                        >
                            ×
                        </button>
                    </div>

                    <div className="preview-modal-body">
                        {/* ⚠️ Aviso */}
                        <div className="backup-info-message" style={{
                            background: 'rgba(255, 149, 0, 0.08)',
                            borderColor: 'rgba(255, 149, 0, 0.2)',
                            marginBottom: '1.5rem'
                        }}>
                            <Icon name="warning" size={20} color="var(--apple-orange)" />
                            <p style={{ margin: 0 }}>
                                <strong>Atenção:</strong> O restauro insere documentos novos e
                                substitui documentos existentes com o mesmo <code>_id</code>.
                                Não elimina dados que não estejam no ficheiro.
                            </p>
                        </div>

                        {!restauroResultado && (
                            <>
                                <div className="form-group" style={{ marginBottom: '1.5rem' }}>
                                    <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 600 }}>
                                        Ficheiro de Backup (.json)
                                    </label>
                                    <input
                                        type="file"
                                        accept=".json,application/json"
                                        onChange={handleFileChangeRestauro}
                                        disabled={restauroLoading}
                                        style={{
                                            display: 'block',
                                            width: '100%',
                                            padding: '0.6rem',
                                            border: '1.5px dashed rgba(0,0,0,0.15)',
                                            borderRadius: '8px',
                                            cursor: restauroLoading ? 'not-allowed' : 'pointer',
                                            background: 'var(--apple-gray-light)'
                                        }}
                                    />
                                    {restauroFile && (
                                        <small style={{
                                            display: 'block',
                                            marginTop: '0.5rem',
                                            color: 'var(--apple-green)',
                                            fontWeight: 500
                                        }}>
                                            ✅ {restauroFile.name} ({(restauroFile.size / 1024 / 1024).toFixed(2)} MB)
                                        </small>
                                    )}
                                </div>

                                {restauroLoading && restauroProgresso > 0 && (
                                    <div style={{ marginBottom: '1.5rem' }}>
                                        <div style={{
                                            height: '8px',
                                            background: 'var(--apple-gray-light)',
                                            borderRadius: '100px',
                                            overflow: 'hidden'
                                        }}>
                                            <div style={{
                                                height: '100%',
                                                width: `${restauroProgresso}%`,
                                                background: 'linear-gradient(90deg, #007AFF, #409CFF)',
                                                transition: 'width 0.3s ease',
                                                borderRadius: '100px'
                                            }} />
                                        </div>
                                        <small style={{
                                            display: 'block',
                                            textAlign: 'center',
                                            marginTop: '0.3rem',
                                            color: 'var(--color-info-dark)'
                                        }}>
                                            A enviar: {restauroProgresso}%
                                        </small>
                                    </div>
                                )}
                            </>
                        )}

                        {restauroResultado && (
                            <div style={{
                                padding: '1rem',
                                borderRadius: '12px',
                                background: restauroResultado.success
                                    ? 'rgba(52, 199, 89, 0.08)'
                                    : 'rgba(255, 59, 48, 0.08)',
                                border: `1.5px solid ${restauroResultado.success
                                    ? 'rgba(52, 199, 89, 0.3)'
                                    : 'rgba(255, 59, 48, 0.3)'}`,
                                marginBottom: '1rem'
                            }}>
                                <h4 style={{
                                    margin: '0 0 0.5rem 0',
                                    color: restauroResultado.success
                                        ? 'var(--apple-green)'
                                        : 'var(--apple-red)'
                                }}>
                                    {restauroResultado.success ? '✅ Sucesso' : '❌ Erro'}
                                </h4>
                                <p style={{ margin: '0 0 0.5rem 0', fontSize: '0.85rem' }}>
                                    {restauroResultado.mensagem}
                                </p>

                                {restauroResultado.colecoesRestauradas !== undefined && (
                                    <div style={{
                                        display: 'grid',
                                        gridTemplateColumns: '1fr 1fr',
                                        gap: '0.5rem',
                                        marginTop: '0.75rem'
                                    }}>
                                        <div>
                                            <small style={{ color: 'var(--color-info-dark)' }}>Coleções:</small>
                                            <div style={{ fontWeight: 700 }}>{restauroResultado.colecoesRestauradas}</div>
                                        </div>
                                        <div>
                                            <small style={{ color: 'var(--color-info-dark)' }}>Documentos:</small>
                                            <div style={{ fontWeight: 700 }}>{restauroResultado.documentosRestaurados}</div>
                                        </div>
                                    </div>
                                )}

                                {restauroResultado.erros && restauroResultado.erros.length > 0 && (
                                    <details style={{ marginTop: '0.75rem' }}>
                                        <summary style={{ cursor: 'pointer', fontSize: '0.8rem' }}>
                                            ⚠️ {restauroResultado.erros.length} erros
                                        </summary>
                                        <ul style={{ marginTop: '0.5rem', paddingLeft: '1.2rem', fontSize: '0.75rem' }}>
                                            {restauroResultado.erros.slice(0, 5).map((e, i) => (
                                                <li key={i}>
                                                    <strong>{e.colecao}:</strong> {e.erro}
                                                </li>
                                            ))}
                                        </ul>
                                    </details>
                                )}
                            </div>
                        )}

                        <div className="preview-footer" style={{ display: 'flex', gap: '0.8rem', justifyContent: 'flex-end' }}>
                            {!restauroResultado && (
                                <>
                                    <button
                                        className="btn-preview-close"
                                        onClick={fecharModalRestauro}
                                        disabled={restauroLoading}
                                    >
                                        Cancelar
                                    </button>
                                    <button
                                        className="btn-backup"
                                        onClick={executarRestauro}
                                        disabled={!restauroFile || restauroLoading}
                                        style={{
                                            background: 'linear-gradient(135deg, #ff9500, #ff6b00)',
                                            opacity: (!restauroFile || restauroLoading) ? 0.5 : 1
                                        }}
                                    >
                                        {restauroLoading ? (
                                            <>
                                                <span className="spinner-small"></span>
                                                A restaurar...
                                            </>
                                        ) : (
                                            <>
                                                <Icon name="restore" size={16} />
                                                Restaurar
                                            </>
                                        )}
                                    </button>
                                </>
                            )}
                            {restauroResultado && (
                                <button className="btn-preview-close" onClick={fecharModalRestauro}>
                                    Fechar
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    // ==============================================
    // 🔥 RENDER SEÇÃO PERSONALIZAÇÃO
    // ==============================================
    const renderPersonalizacao = () => {
        const brilhoCor = calcularBrilho(coresData.corPrimaria);
        const textoCor = brilhoCor < 128 ? '#ffffff' : '#1a1a2e';
        const isWhite = coresData.corPrimaria?.toUpperCase() === '#FFFFFF' || coresData.corPrimaria?.toLowerCase() === '#ffffff';

        const isDarkMode = document.body.classList.contains('dark-mode-variables');

        return (
            <div className="definicoes-section">
                <div className="section-header">
                    <h2>
                        <Icon name="palette" size={24} color="var(--apple-blue)" />
                        Personalização
                    </h2>
                    <p>Personalize a cor do header, idioma e configure as notícias</p>
                </div>

                <div className="section-content">

                    {/* PARTE 1: PERSONALIZAÇÃO DE CORES */}
                    <div className="personalizacao-subsection">
                        <h3 className="subsection-title">
                            <Icon name="color_lens" size={18} color="var(--apple-blue)" />
                            Cor do Header
                        </h3>

                        <div className="personalizacao-empresa-info">
                            <div className="info-icon">
                                <Icon name="apartment" size={18} color="var(--apple-blue)" />
                            </div>
                            <div className="info-text">
                                <span className="info-label">A personalizar para:</span>
                                <span className="info-value">{perfilData.empresaNome || 'Sem empresa'}</span>
                            </div>
                            {coresLoading && <span className="loading-spinner-small"></span>}
                        </div>

                        <div className="personalizacao-preview" style={{
                            background: coresData.corPrimaria || '#6C9BCF',
                            padding: '1.5rem',
                            borderRadius: '12px',
                            marginBottom: '1.5rem',
                            color: textoCor,
                            border: isWhite ? '2px solid #e0e0e0' : 'none',
                            transition: 'all 0.3s ease'
                        }}>
                            <h4 style={{ margin: 0, color: textoCor, fontWeight: 600 }}>
                                🎨 Pré-visualização
                            </h4>
                            <p style={{ opacity: 0.8, margin: '0.3rem 0 0', color: textoCor }}>
                                Esta é a aparência do header com a cor selecionada
                            </p>
                            <div style={{
                                marginTop: '1rem',
                                display: 'flex',
                                gap: '0.5rem',
                                alignItems: 'center'
                            }}>
                                <span style={{
                                    display: 'inline-block',
                                    padding: '0.3rem 1rem',
                                    background: isWhite ? 'rgba(0,0,0,0.08)' : 'rgba(255,255,255,0.2)',
                                    borderRadius: '8px',
                                    fontSize: '0.7rem',
                                    fontWeight: 500,
                                    color: textoCor
                                }}>
                                    RAF ERP
                                </span>
                                <span style={{
                                    display: 'inline-block',
                                    padding: '0.3rem 0.8rem',
                                    background: isWhite ? 'rgba(0,0,0,0.05)' : 'rgba(255,255,255,0.15)',
                                    borderRadius: '8px',
                                    fontSize: '0.65rem',
                                    color: textoCor,
                                    opacity: 0.7
                                }}>
                                    {coresData.corPrimaria}
                                </span>
                            </div>
                        </div>

                        <div className="form-group">
                            <label>Selecione a Cor do Header</label>
                            <div className="cores-grid">
                                {coresPreDefinidas.map((item) => {
                                    const isSelected = coresData.corPrimaria === item.cor;
                                    const brilho = calcularBrilho(item.cor);
                                    const isWhiteColor = item.cor?.toUpperCase() === '#FFFFFF' || item.cor?.toLowerCase() === '#ffffff';

                                    return (
                                        <button
                                            key={item.cor}
                                            type="button"
                                            className={`cor-option ${isSelected ? 'selected' : ''}`}
                                            data-cor={item.cor}
                                            style={{
                                                backgroundColor: item.cor,
                                                border: isWhiteColor
                                                    ? '2px solid #e0e0e0'
                                                    : isSelected
                                                        ? '3px solid var(--apple-blue)'
                                                        : '2px solid transparent',
                                                boxShadow: isSelected ? '0 0 0 2px var(--apple-blue)' : 'none'
                                            }}
                                            onClick={() => setCoresData({ corPrimaria: item.cor })}
                                            title={item.nome}
                                        >
                                            {isSelected && (
                                                <span className="cor-check" style={{ color: brilho < 128 ? '#ffffff' : '#1a1a2e' }}>
                                                    ✓
                                                </span>
                                            )}
                                            <span className="cor-tooltip">{item.nome}</span>
                                        </button>
                                    );
                                })}
                            </div>
                            <small style={{ display: 'block', marginTop: '0.5rem', color: 'var(--color-info-dark)' }}>
                                <Icon name="info" size={12} style={{ marginRight: '4px' }} />
                                Selecione uma cor para o header. Clique em "Salvar Cor" para aplicar.
                            </small>
                        </div>

                        <div className="form-actions" style={{ display: 'flex', gap: '0.8rem', flexWrap: 'wrap' }}>
                            <button
                                className="btn-save"
                                onClick={salvarCorNaEmpresa}
                                disabled={coresLoading}
                            >
                                {coresLoading ? (
                                    <>
                                        <span className="spinner-small"></span> A salvar...
                                    </>
                                ) : (
                                    <>
                                        <Icon name="save" size={16} /> Salvar Cor
                                    </>
                                )}
                            </button>
                            <button className="btn-reset" onClick={resetarCor}>
                                <Icon name="refresh" size={16} /> Restaurar Padrão
                            </button>
                        </div>

                        {!perfilData.empresaId && (
                            <div className="alert-warning" style={{ marginTop: '1rem' }}>
                                <Icon name="warning" size={16} />
                                <span>Nenhuma empresa associada à sua conta. Contacte o administrador.</span>
                            </div>
                        )}
                    </div>

                    {/* PARTE 2: IDIOMA */}
                    <div className="personalizacao-subsection" style={{ marginTop: '2rem', paddingTop: '1.5rem', borderTop: '1px solid rgba(0,0,0,0.06)' }}>
                        <h3 className="subsection-title">
                            <Icon name="language" size={18} color="var(--apple-blue)" />
                            Idioma do Sistema
                        </h3>

                        <div className="form-group" style={{ maxWidth: '400px', position: 'relative' }}>
                            <label>Selecione o idioma principal do sistema</label>

                            <div style={{ position: 'relative', width: '100%' }}>
                                <select
                                    value={idiomaData.idioma}
                                    onChange={(e) => setIdiomaData({ idioma: e.target.value })}
                                    style={{
                                        padding: '0.6rem 2.8rem 0.6rem 0.9rem',
                                        border: '1.5px solid rgba(0, 0, 0, 0.06)',
                                        borderRadius: 'var(--apple-radius-sm)',
                                        fontSize: '0.85rem',
                                        fontFamily: 'inherit',
                                        background: 'var(--apple-white)',
                                        color: 'var(--color-dark)',
                                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                        width: '100%',
                                        appearance: 'none',
                                        WebkitAppearance: 'none',
                                        MozAppearance: 'none',
                                        cursor: 'pointer',
                                        minHeight: '44px',
                                        lineHeight: '1.4',
                                        paddingRight: '2.8rem'
                                    }}
                                    className="idioma-select"
                                >
                                    {idiomasDisponiveis.map((opcao) => (
                                        <option key={opcao.valor} value={opcao.valor}>
                                            {opcao.label}
                                        </option>
                                    ))}
                                </select>

                                <svg
                                    viewBox="0 0 12 8"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{
                                        position: 'absolute',
                                        right: '1rem',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        width: '12px',
                                        height: '8px',
                                        pointerEvents: 'none',
                                        zIndex: 2,
                                        opacity: 0.6,
                                        transition: 'all 0.3s ease'
                                    }}
                                    className="select-arrow-icon"
                                >
                                    <path
                                        d="M1 1l5 5 5-5"
                                        stroke={isDarkMode ? '#F2F2F7' : '#8E8E93'}
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                    />
                                </svg>
                            </div>

                            <small style={{ display: 'block', marginTop: '0.5rem', color: 'var(--color-info-dark)' }}>
                                <Icon name="info" size={12} style={{ marginRight: '4px' }} />
                                O idioma selecionado será aplicado em todo o sistema para esta empresa.
                            </small>
                        </div>

                        <div className="form-actions" style={{ marginTop: '0.8rem' }}>
                            <button
                                className="btn-save"
                                onClick={salvarIdiomaNaEmpresa}
                                disabled={idiomaLoading}
                            >
                                {idiomaLoading ? (
                                    <>
                                        <span className="spinner-small"></span> A salvar...
                                    </>
                                ) : (
                                    <>
                                        <Icon name="save" size={16} /> Salvar Idioma
                                    </>
                                )}
                            </button>
                        </div>
                    </div>

                    {/* PARTE 3: CONFIGURAÇÃO DE NOTÍCIAS */}
                    <div className="personalizacao-subsection noticias-config" style={{ marginTop: '2rem', paddingTop: '1.5rem', borderTop: '1px solid rgba(0,0,0,0.06)' }}>
                        <h3 className="subsection-title">
                            <Icon name="newspaper" size={18} color="var(--apple-blue)" />
                            Configuração de Notícias
                        </h3>

                        <div className="noticias-toggle-container">
                            <div className="toggle-info">
                                <span className="toggle-label">Módulo de Notícias</span>
                                <span className="toggle-status">
                                    {noticiasConfig.ativo ? (
                                        <span className="status-active">✅ Ativo</span>
                                    ) : (
                                        <span className="status-inactive">❌ Desativado</span>
                                    )}
                                </span>
                            </div>
                            <button
                                className={`toggle-slider-btn ${noticiasConfig.ativo ? 'active' : 'inactive'}`}
                                onClick={toggleModuloNoticias}
                                disabled={noticiasLoading}
                            >
                                <span className="toggle-track">
                                    <span className="toggle-thumb"></span>
                                </span>
                            </button>
                        </div>

                        <small style={{ display: 'block', marginBottom: '1.5rem', color: 'var(--color-info-dark)' }}>
                            <Icon name="info" size={12} style={{ marginRight: '4px' }} />
                            {noticiasConfig.ativo ?
                                'O módulo de notícias está ativo e visível no menu.' :
                                'O módulo de notícias está desativado e não aparecerá no menu.'}
                        </small>

                        <div className="noticias-fontes-list">
                            <div className="fontes-header">
                                <label>Fontes de Notícias (máx. 5)</label>
                                <span className="fontes-count">{noticiasConfig.fontes.length}/5</span>
                            </div>

                            {noticiasConfig.fontes.length === 0 ? (
                                <div className="fontes-empty">
                                    <Icon name="info" size={24} color="var(--color-info-dark)" />
                                    <p>Nenhuma fonte adicionada. Adicione até 5 fontes RSS.</p>
                                </div>
                            ) : (
                                <div className="fontes-grid">
                                    {noticiasConfig.fontes.map((fonte, index) => (
                                        <div key={fonte.id} className="fonte-item">
                                            <div className="fonte-info">
                                                <div className="fonte-ativo">
                                                    <button
                                                        className={`fonte-toggle-btn ${fonte.ativo ? 'active' : 'inactive'}`}
                                                        onClick={() => toggleFonteAtiva(fonte.id)}
                                                        title={fonte.ativo ? 'Desativar fonte' : 'Ativar fonte'}
                                                    >
                                                        <span className={`dot ${fonte.ativo ? 'active' : 'inactive'}`}></span>
                                                    </button>
                                                </div>

                                                <div className="fonte-dados">
                                                    <span className="fonte-nome">{fonte.nome}</span>
                                                    <span className="fonte-url">{fonte.url}</span>
                                                </div>
                                            </div>
                                            <div className="fonte-acoes">
                                                <button
                                                    className="fonte-remover"
                                                    onClick={() => removerFonte(fonte.id)}
                                                    title="Remover fonte"
                                                >
                                                    <Icon name="delete" size={16} color="var(--color-danger)" />
                                                </button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}

                            {noticiasConfig.fontes.length < 5 && (
                                <div className="fonte-adicionar">
                                    <div className="add-fonte-inputs">
                                        <input
                                            type="text"
                                            placeholder="Nome da fonte (ex: VOA)"
                                            value={novaFonte.nome}
                                            onChange={(e) => setNovaFonte({ ...novaFonte, nome: e.target.value })}
                                        />
                                        <input
                                            type="url"
                                            placeholder="URL do feed RSS"
                                            value={novaFonte.url}
                                            onChange={(e) => setNovaFonte({ ...novaFonte, url: e.target.value })}
                                        />
                                        <button
                                            className="btn-add-fonte"
                                            onClick={adicionarFonte}
                                            disabled={!novaFonte.nome.trim() || !novaFonte.url.trim()}
                                        >
                                            <Icon name="add" size={16} />
                                            Adicionar
                                        </button>
                                    </div>
                                    <small style={{ display: 'block', marginTop: '0.5rem', color: 'var(--color-info-dark)' }}>
                                        <Icon name="info" size={12} style={{ marginRight: '4px' }} />
                                        Insira o nome e a URL do feed RSS da fonte de notícias.
                                    </small>
                                </div>
                            )}
                        </div>

                        <div className="form-actions" style={{ marginTop: '1.5rem' }}>
                            <button
                                className="btn-save"
                                onClick={salvarConfigNoticias}
                                disabled={noticiasLoading}
                            >
                                {noticiasLoading ? (
                                    <>
                                        <span className="spinner-small"></span> A salvar...
                                    </>
                                ) : (
                                    <>
                                        <Icon name="save" size={16} /> Salvar Configuração
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    // ==============================================
    // RENDER SEÇÃO PERFIL
    // ==============================================
    const renderPerfil = () => {
        const imagemUrl = perfilData.imagemPerfil ? getImagemUrl(perfilData.imagemPerfil) : null;

        return (
            <div className="definicoes-section">
                <div className="section-header">
                    <h2>
                        <Icon name="person_outline" size={24} color="var(--apple-blue)" />
                        Perfil
                    </h2>
                    <p>Gerencie as suas informações pessoais</p>
                </div>

                <div className="section-content">
                    <div className="perfil-avatar-section">
                        <Avatar
                            name={perfilData.nome || '?'}
                            src={imagemUrl}
                            size={80}
                        />
                        <div className="perfil-avatar-info">
                            <h3>{perfilData.nome || 'Utilizador'}</h3>
                            <span className="perfil-email">{perfilData.email}</span>
                            <span className={`perfil-badge ${perfilData.perfil?.toLowerCase()}`}>
                                {perfilData.perfil || 'Normal'}
                            </span>
                        </div>
                    </div>

                    <div className="form-grid">
                        <div className="form-group">
                            <label>Nome completo *</label>
                            <input
                                type="text"
                                value={perfilData.nome}
                                onChange={(e) => setPerfilData({ ...perfilData, nome: e.target.value })}
                                placeholder="Seu nome completo"
                            />
                        </div>
                        <div className="form-group">
                            <label>Email</label>
                            <input
                                type="email"
                                value={perfilData.email}
                                disabled
                                className="field-disabled"
                            />
                            <small>O email não pode ser alterado</small>
                        </div>
                        <div className="form-group">
                            <label>Empresa</label>
                            <input
                                type="text"
                                value={perfilData.empresaNome || 'Sem empresa'}
                                disabled
                                className="field-disabled"
                            />
                            <small>Empresa associada à sua conta</small>
                        </div>
                    </div>

                    <div className="form-actions">
                        <button className="btn-save" onClick={atualizarPerfil} disabled={loading}>
                            {loading ? 'A guardar...' : 'Guardar Alterações'}
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    // ==============================================
    // RENDER SEÇÃO SEGURANÇA
    // ==============================================
    const renderSeguranca = () => {
        return (
            <div className="definicoes-section">
                <div className="section-header">
                    <h2>
                        <Icon name="security" size={24} color="var(--apple-blue)" />
                        Segurança
                    </h2>
                    <p>Altere a sua senha e configure a segurança da conta</p>
                </div>

                <div className="section-content">
                    <div className="security-info">
                        <div className="security-icon">
                            <Icon name="shield" size={40} color="var(--apple-green)" />
                        </div>
                        <div className="security-text">
                            <h4>Proteja a sua conta</h4>
                            <p>Utilize uma senha forte com pelo menos 6 caracteres, incluindo letras, números e símbolos.</p>
                        </div>
                    </div>

                    <div className="form-grid">
                        <div className="form-group">
                            <label>Senha atual *</label>
                            <input
                                type="password"
                                value={segurancaData.senhaAtual}
                                onChange={(e) => setSegurancaData({ ...segurancaData, senhaAtual: e.target.value })}
                                placeholder="Digite a senha atual"
                            />
                        </div>
                        <div className="form-group">
                            <label>Nova senha *</label>
                            <input
                                type="password"
                                value={segurancaData.novaSenha}
                                onChange={(e) => setSegurancaData({ ...segurancaData, novaSenha: e.target.value })}
                                placeholder="Mínimo 6 caracteres"
                            />
                        </div>
                        <div className="form-group">
                            <label>Confirmar nova senha *</label>
                            <input
                                type="password"
                                value={segurancaData.confirmarSenha}
                                onChange={(e) => setSegurancaData({ ...segurancaData, confirmarSenha: e.target.value })}
                                placeholder="Repita a nova senha"
                            />
                            {segurancaData.novaSenha && segurancaData.confirmarSenha && (
                                <small className={segurancaData.novaSenha === segurancaData.confirmarSenha ? 'text-success' : 'text-danger'}>
                                    {segurancaData.novaSenha === segurancaData.confirmarSenha ? '✅ Senhas coincidem' : '❌ Senhas não coincidem'}
                                </small>
                            )}
                        </div>
                    </div>

                    <div className="form-actions">
                        <button className="btn-save" onClick={alterarSenha} disabled={loading}>
                            {loading ? 'A alterar...' : 'Alterar Senha'}
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    // ==============================================
    // RENDER SEÇÃO BACKUP
    // ==============================================
    const renderBackup = () => {
        return (
            <div className="definicoes-section">
                <div className="section-header">
                    <h2>
                        <Icon name="backup" size={24} color="var(--apple-blue)" />
                        Backup da Base de Dados
                    </h2>
                    <p>Faça o download de um backup completo da base de dados</p>
                </div>

                <div className="section-content">
                    <div className="backup-info-message">
                        <Icon name="info" size={20} color="var(--apple-blue)" />
                        <p>
                            O backup será gerado em tempo real e baixado diretamente para o seu computador
                            em formato <strong>JSON</strong>. Nenhum ficheiro é armazenado no servidor.
                        </p>
                    </div>

                    {isSuperadmin && (
                        <div className="backup-empresa-selector">
                            <label htmlFor="empresaBackup">Selecionar Empresa:</label>
                            <select
                                id="empresaBackup"
                                value={empresaSelecionada}
                                onChange={(e) => setEmpresaSelecionada(e.target.value)}
                                className="backup-select"
                                disabled={carregandoEmpresas}
                            >
                                <option value="">🌐 Todas as Empresas (Backup Completo)</option>
                                {empresasBackup.map(emp => (
                                    <option key={emp._id} value={emp._id}>
                                        🏢 {emp.nome}
                                    </option>
                                ))}
                            </select>
                            <small>
                                {empresaSelecionada ?
                                    '🔒 Backup apenas da empresa selecionada' :
                                    '🌐 Backup completo de todas as empresas'}
                            </small>
                            {carregandoEmpresas && (
                                <small className="loading-text">⏳ A carregar empresas...</small>
                            )}
                        </div>
                    )}

                    <div className="backup-info-grid">
                        <div className="backup-info-card">
                            <div className="backup-info-icon">
                                <Icon name="cloud_download" size={28} color="var(--apple-blue)" />
                            </div>
                            <div className="backup-info-text">
                                <span className="backup-label">Último Download</span>
                                <span className="backup-value">
                                    {backupData.ultimoBackup ?
                                        new Date(backupData.ultimoBackup).toLocaleString('pt-PT') :
                                        'Nunca realizado'}
                                </span>
                            </div>
                        </div>
                        <div className="backup-info-card">
                            <div className="backup-info-icon">
                                <Icon name="storage" size={28} color="var(--apple-green)" />
                            </div>
                            <div className="backup-info-text">
                                <span className="backup-label">Último Tamanho</span>
                                <span className="backup-value">{backupData.tamanhoBackup}</span>
                            </div>
                        </div>
                        <div className="backup-info-card">
                            <div className="backup-info-icon">
                                <Icon name="receipt_long" size={28} color="var(--apple-orange)" />
                            </div>
                            <div className="backup-info-text">
                                <span className="backup-label">Backups</span>
                                <span className="backup-value">{backupData.backupsDisponiveis.length}</span>
                            </div>
                        </div>
                    </div>

                    <div className="backup-actions">
                        <button
                            className="btn-backup"
                            onClick={baixarBackup}
                            disabled={backupData.backupEmAndamento}
                        >
                            {backupData.backupEmAndamento ? (
                                <>
                                    <span className="spinner-small"></span>
                                    A gerar backup...
                                </>
                            ) : (
                                <>
                                    <Icon name="cloud_download" size={18} />
                                    Baixar Backup
                                    {isSuperadmin && empresaSelecionada && ' da Empresa'}
                                </>
                            )}
                        </button>

                        <button
                            className="btn-preview"
                            onClick={previewBackup}
                            disabled={backupData.backupEmAndamento || previewLoading}
                        >
                            {previewLoading ? (
                                <>
                                    <span className="spinner-small"></span>
                                    A carregar...
                                </>
                            ) : (
                                <>
                                    <Icon name="visibility" size={18} />
                                    Ver Informações
                                </>
                            )}
                        </button>

                        {/* 🔥 NOVO BOTÃO: Restaurar Backup (só Superadmin) */}
                        {isSuperadmin && (
                            <button
                                className="btn-reset"
                                onClick={abrirModalRestauro}
                                style={{
                                    borderColor: 'var(--apple-orange)',
                                    color: 'var(--apple-orange)'
                                }}
                                title="Restaurar um ficheiro de backup JSON"
                            >
                                <Icon name="restore" size={18} />
                                Restaurar Backup
                            </button>
                        )}
                    </div>

                    {backupData.backupsDisponiveis.length > 0 && (
                        <div className="backup-list">
                            <h4>📋 Histórico de Downloads</h4>
                            <div className="backup-table-wrapper">
                                <table className="backup-table">
                                    <thead>
                                        <tr>
                                            <th>Ficheiro</th>
                                            <th>Data</th>
                                            <th>Tamanho</th>
                                            <th>Tipo</th>
                                            <th>Ações</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {backupData.backupsDisponiveis.map((backup) => (
                                            <tr key={backup.id}>
                                                <td>
                                                    <Icon name="description" size={16} color="var(--apple-blue)" />
                                                    <span className="backup-nome">{backup.nome}</span>
                                                </td>
                                                <td>{new Date(backup.data).toLocaleString('pt-PT')}</td>
                                                <td>{backup.tamanho}</td>
                                                <td>
                                                    <span className={`backup-tipo ${backup.tipo === 'Empresa Específica' ? 'empresa' : 'completo'}`}>
                                                        {backup.tipo}
                                                    </span>
                                                </td>
                                                <td>
                                                    <div className="backup-actions-cell">
                                                        <button
                                                            className="action-btn delete"
                                                            onClick={() => eliminarBackup(backup.id)}
                                                            title="Remover do histórico"
                                                        >
                                                            <Icon name="delete" size={16} />
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            <small className="backup-note">
                                ℹ️ Apenas registo local dos backups baixados. Os ficheiros estão no seu computador.
                            </small>
                        </div>
                    )}
                </div>
            </div>
        );
    };

    // ==============================================
    // RENDER SEÇÃO SOBRE
    // ==============================================
    const renderSobre = () => {
        return (
            <div className="definicoes-section">
                <div className="section-header">
                    <h2>
                        <Icon name="info_outline" size={24} color="var(--apple-blue)" />
                        Sobre
                    </h2>
                    <p>Informações sobre o sistema</p>
                </div>

                <div className="section-content">
                    <div className="sobre-card">
                        <div className="sobre-logo">
                            <div className="logo-icon">🚀</div>
                            <h2>RAF ERP</h2>
                            <span className="version">v1.0.0</span>
                        </div>

                        <div className="sobre-info">
                            <div className="info-item">
                                <span className="label">Sistema</span>
                                <span className="value">RAF ERP - Gestão Empresarial</span>
                            </div>
                            <div className="info-item">
                                <span className="label">Versão</span>
                                <span className="value">1.0.0</span>
                            </div>
                            <div className="info-item">
                                <span className="label">Status</span>
                                <span className="value status-online">🟢 Online</span>
                            </div>
                            <div className="info-item">
                                <span className="label">Utilizador</span>
                                <span className="value">{loggedUser?.nome || 'Não autenticado'}</span>
                            </div>
                            <div className="info-item">
                                <span className="label">Perfil</span>
                                <span className={`value badge ${loggedUser?.perfil?.toLowerCase()}`}>
                                    {loggedUser?.perfil || 'Normal'}
                                </span>
                            </div>
                            <div className="info-item">
                                <span className="label">Empresa</span>
                                <span className="value">{perfilData.empresaNome || 'Sem empresa'}</span>
                            </div>
                        </div>

                        <div className="sobre-footer">
                            <p>© 2026 RAF ERP. Todos os direitos reservados.</p>
                            <p className="sobre-creditos">Desenvolvido com ❤️ pela equipa RAF</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    // ==============================================
    // RENDER CONTEÚDO DA SEÇÃO ATIVA
    // ==============================================
    const renderActiveSection = () => {
        switch (activeSection) {
            case 'perfil':
                return renderPerfil();
            case 'seguranca':
                return renderSeguranca();
            case 'personalizacao':
                return renderPersonalizacao();
            case 'backup':
                return renderBackup();
            case 'sobre':
                return renderSobre();
            default:
                return renderPerfil();
        }
    };

    // ==============================================
    // SEÇÕES DO MENU - CARDS
    // ==============================================
    const sections = [
        { id: 'perfil', icon: 'person_outline', label: 'Perfil', description: 'Gerir informações pessoais' },
        { id: 'seguranca', icon: 'security', label: 'Segurança', description: 'Alterar senha e segurança' },
        { id: 'personalizacao', icon: 'palette', label: 'Personalização', description: 'Cor do header, idioma e notícias' },
        ...(isSuperadmin || isAdmin ? [
            { id: 'backup', icon: 'backup', label: 'Backup', description: 'Gerir backups da base de dados' },
        ] : []),
        { id: 'sobre', icon: 'info_outline', label: 'Sobre', description: 'Informações do sistema' },
    ];

    // ==============================================
    // 🔥 RENDER PRINCIPAL
    // ==============================================
    return (
        <div className="definicoes-container">
            <div className="definicoes-header">
                <div className="header-title">
                    <h1>
                        <Icon name="settings" size={28} color="var(--apple-blue)" />
                        Definições
                    </h1>
                    <p>Gerencie as configurações da sua conta e do sistema</p>
                </div>
            </div>

            <div className="definicoes-cards-wrapper">
                <div className="definicoes-cards">
                    {sections.map((section) => (
                        <button
                            key={section.id}
                            className={`definicoes-card ${activeSection === section.id ? 'active' : ''}`}
                            onClick={() => setActiveSection(section.id)}
                            title={section.description}
                        >
                            <div className="definicoes-card-icon">
                                <Icon name={section.icon} size={22} />
                            </div>
                            <div className="definicoes-card-content">
                                <span className="definicoes-card-label">{section.label}</span>
                                <span className="definicoes-card-description">{section.description}</span>
                            </div>
                            {activeSection === section.id && (
                                <span className="definicoes-card-indicator"></span>
                            )}
                        </button>
                    ))}
                </div>
            </div>

            <div className="definicoes-content">
                {renderActiveSection()}
            </div>

            {renderPreviewModal()}
            {renderRestauroModal()}
            {renderToast()}
        </div>
    );
}